import { render } from "./BannerHeader.vue?vue&type=template&id=35287eb2&scoped=true&ts=true"
import script from "./BannerHeader.vue?vue&type=script&lang=ts"
export * from "./BannerHeader.vue?vue&type=script&lang=ts"

import "./BannerHeader.vue?vue&type=style&index=0&id=35287eb2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35287eb2"]])

export default __exports__